export var PaymentPayloadType;
(function (PaymentPayloadType) {
    PaymentPayloadType[PaymentPayloadType["attendeeFormUpdate"] = 0] = "attendeeFormUpdate";
    PaymentPayloadType[PaymentPayloadType["attendeeTypeChange"] = 1] = "attendeeTypeChange";
    PaymentPayloadType[PaymentPayloadType["attendeePaymentUpdate"] = 2] = "attendeePaymentUpdate";
    PaymentPayloadType[PaymentPayloadType["bulkAttendeePaymentUpdate"] = 3] = "bulkAttendeePaymentUpdate";
    PaymentPayloadType[PaymentPayloadType["attendeeCancel"] = 4] = "attendeeCancel";
})(PaymentPayloadType || (PaymentPayloadType = {}));
export var PostAttendeeActionsActionTypes;
(function (PostAttendeeActionsActionTypes) {
    PostAttendeeActionsActionTypes["GET_LOOKUPS"] = "GET_LOOKUPS";
    PostAttendeeActionsActionTypes["SET_LOOKUPS"] = "SET_LOOKUPS";
    PostAttendeeActionsActionTypes["GET_ATTENDEES"] = "GET_ATTENDEES";
    PostAttendeeActionsActionTypes["SET_ATTENDEES"] = "SET_ATTENDEES";
    PostAttendeeActionsActionTypes["GET_ORDERS"] = "GET_ORDERS";
    PostAttendeeActionsActionTypes["SET_ORDERS"] = "SET_ORDERS";
    PostAttendeeActionsActionTypes["GET_GROUP"] = "GET_GROUP";
    PostAttendeeActionsActionTypes["SET_GROUP"] = "SET_GROUP";
    PostAttendeeActionsActionTypes["SET_PAYMENT_REQUIRED_PAYLOAD"] = "SET_PAYMENT_REQUIRED_PAYLOAD";
})(PostAttendeeActionsActionTypes || (PostAttendeeActionsActionTypes = {}));
